<template v-slot:default="{ isActive }">
  <v-dialog
    v-model="dialog"
    width="60rem"
    class="layer-popup"
    scrollable
  >
    <v-card>
      <!--content-->
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="pop-title">
          {{ popTitle }}
          <span class="pop-title02">{{ popSubTitle }}</span>
        </div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click.stop="dialog = false"
        ></v-btn>
      </v-card-title>
      <!--content-->
      <v-card-text>
        <div class="dropdown-group ty01">
          <div class="form-group col-ty">
            <div class="form-row02"
                 v-for="(item, i) in items"
                 :key="i">
              <c-Input :placeholder="t('message.enterLocation')" class="size03" v-model="item.place" :name="'place'+i"/>
              <c-btn02 :btnText="t('message.delete')" class="" @click.stop="deleteRow(i)"/>
            </div>
          </div>
        </div>
      </v-card-text>
      <!--버튼-->
      <v-card-actions class="d-flex justify-end pop-bottom-bg"><!--pop-bottom-bg-->
        <c-btnLine01 :btnText="t('message.add')" class="" @click.stop="addRow()"/>
        <c-btn01 v-bind="btnSave" @click="handleForm"/>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import BbsService from "@/services/bbs.service";
import CompanyService from "@/services/company.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps(['popTitle', 'popSubTitle'])
const emit = defineEmits(['close'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//ui
const btnSave = {
  btnText: t('message.save'),
}

//bind
const snackbar = ref(false)
const snackText = ref('')
const items = ref([])

//hook
onBeforeUpdate (()=>{
  items.value = []
})

onUpdated(() => {
  if(dialog.value)
    getData()
})

//function
function getData(){
  let companyIdx = localStorage.getItem('companyIdx')
  //let monitoringIdx = storeRef.popupIdx.value
  let params = {
    companyIdx: companyIdx,
    //monitoringIdx: monitoringIdx
  }

  BbsService.getMonitoringPlaceList(params).then(
    (response) => {
      items.value = response.result
      if(response.result.length == 0)
        addRow()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

function addRow(){
  let row = {
    place: '',
    idx: '',
  }
  items.value.push(row)
}

function deleteRow(index){
  items.value.splice(index, 1)
}

function handleForm(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    let companyIdx = localStorage.getItem('companyIdx')
    let params = {
      companyIdx: companyIdx,
      monitoringPlaces: items.value
    }

    BbsService.insertMonitoringPlace(params).then(
      (response) => {
        emit('close', 'refresh')
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )
  }
}
</script>


<style lang="scss">

</style>
